// Feature-detecting polyfills for APIs pdfjs-dist@5 relies on that older
// Safari lacks (Safari 16.1 macOS: Promise.withResolvers; iOS Safari 17.6:
// URL.parse). Must be imported first in the entry point, before pdfjs-dist
// ever runs — see main.tsx.
//
// `as any` casts below are deliberate: the current tsconfig `lib` target
// predates es2024, and these are lib-typing gaps only — behavior stays
// spec-correct and feature-detected. Do not "fix" by bumping `lib`.

const P = Promise as any;
if (typeof P.withResolvers !== 'function') {
  P.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

const U = URL as any;
if (typeof U.parse !== 'function') {
  U.parse = function parse(url: string, base?: string): URL | null {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}
